<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container>
    {{
        rowData[fieldDefinition.name]
            | dateTimeFromSql
            | dateTimeToFormat: (fieldDefinition.format || 'yyyy-MM-dd')
    }}
</ng-container>
